<template>

    <trax-ui-card-result
        v-if="!hasNoResult || !hideNoResult"
        :background-color="backgroundColor" 
        :title="title" :result="result" :result-size="resultSize"
    ></trax-ui-card-result>
    
</template>

<script>
    export default {

        props: {
            hideNoResult: null,
        },

        data() {
            return {
                lang: lang,
                state: data.state,
                item: data.item,
            }
        },
        
        computed: {

            passedLabel() {
                if (this.item.type == 'enac-atpl-level-report')
                    return this.lang.polaris.dashboard.satisfactory
                return this.lang.polaris.dashboard.pass;
            },

            failedLabel() {
                if (this.item.type == 'enac-atpl-level-report')
                    return this.lang.polaris.dashboard.unsatisfactory
                return this.lang.polaris.dashboard.fail;
            },

            completedLabel() {
                if (this.item.type == 'enac-atpl-level-report')
                    return this.lang.polaris.dashboard.no_result
                return this.lang.polaris.dashboard.completed;
            },

            resultSize() {
                if (this.item.type == 'enac-atpl-level-report') return 'md';
                if (this.state.partially_passed) return 'md';
                return 'lg';
            },

            backgroundColor() {
                if (!this.state || !this.state.color_status) return 'secondary';
                return this.state.color_status;
            },

            backgroundColor() {
                if (!this.state || !this.state.color_status) return 'secondary';
                return this.state.color_status;
            },

            title() {
                if (this.hasNoResult) {
                    return this.lang.polaris.dashboard.no_result;
                }
                if (this.state.partially_passed) {
                    return null;
                }
                if (this.state.passed != undefined) {
                    if (this.state.grade != undefined) {
                        if (this.state.passed) {
                            return this.lang.polaris.dashboard.learner_passed_with_grade;
                        } else {
                            return this.lang.polaris.dashboard.learner_failed_with_grade;
                        }
                    } else {
                        return null;
                    }
                }
                if (this.state.completed != undefined) {
                    if (this.state.grade != undefined) {
                        return this.lang.polaris.dashboard.learner_completed_with_grade;
                    } else {
                        return null;
                    }
                }
                return this.lang.polaris.dashboard.no_result;
            },

            hasNoResult() {
                return !this.state || (!this.state.partially_passed && this.state.passed == undefined && this.state.completed == undefined)
            },

            result() {
                if (!this.state) return null;
                if (this.state.partially_passed) {
                    return this.lang.polaris.dashboard.partial_pass;
                }
                if (this.state.passed != undefined) {
                    if (this.state.grade != undefined) {
                        return this.state.grade;
                    } else {
                        return this.state.passed 
                            ? this.passedLabel
                            : this.failedLabel;
                    }
                }
                if (this.state.completed != undefined) {
                    if (this.state.grade != undefined) {
                        var grade = this.state.grade;
                        if (this.state.grade_max) grade += '/'+this.state.grade_max;
                        return grade;
                    } else if (this.state.completed) {
                        if (this.item.type == 'enac-atpl-course-session') {
                            return this.lang.polaris.dashboard.attended;
                        } else if (this.item.meta.crew_type == 'solo' && !this.state.validation) {
                            return this.lang.polaris.dashboard.in_progress;
                        } else {
                            return this.lang.polaris.dashboard.completed;
                        }
                    } else {
                        return this.lang.polaris.dashboard.in_progress
                    }
                }
                return null;
            },
        }
    }
</script>
